import BookingModalDetails from "./BookingModalDetails";
export default BookingModalDetails;
